import { errorHandlerWithMessage } from "./errorHandler";

const cognitoConfig = {
  awsRegion: process.env.REACT_APP_AWS_REGION,
  clientId: process.env.REACT_APP_CLIENT_ID,
  userPoolId: process.env.REACT_APP_USER_POOL_ID,
  identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
};

class DummyAuthAdapter {
  addSpinHandler() {}
  removeSpinHandler() {}
  isSpinning() {
    return false;
  }
  signUp() {
    return Promise.reject(
      new Error(
        "sign-in/sign-up disabled because window.localStorage is blocked or non-existent"
      )
    );
  }
  signIn() {
    return Promise.reject(
      new Error(
        "sign-in/sign-up disabled because window.localStorage is blocked or non-existent"
      )
    );
  }
}

class AuthAdapterFactory {
  get authAdapter() {
    if (this._authAdapter) return Promise.resolve(this._authAdapter);

    return this.create().then((authAdapter) => {
      this._authAdapter = authAdapter;
      return this._authAdapter;
    });
  }

  destroy() {
    delete this._authAdapter;
  }

  onAuthError() {
    console.log("caught onAuthError from AuthAdapter");
    // not sure what to do here (can't remember), just leaving it commented out.
    // this.destroy();
    // window.location.href = '/';
  }

  create() {
    return new Promise((resolve, reject) => {
      if (window.supportsLocalStorage()) {
        import("../Auth")
          .then(({ CognitoAuthAdapter }) => {
            return resolve(
              new CognitoAuthAdapter(
                cognitoConfig.awsRegion,
                cognitoConfig.userPoolId,
                cognitoConfig.identityPoolId,
                cognitoConfig.clientId,
                errorHandlerWithMessage,
                this.onAuthError.bind(this)
              )
            );
          })
          .catch(reject);
      } else {
        return resolve(new DummyAuthAdapter());
      }
    });
  }
}

window.authAdapter = new AuthAdapterFactory();

export default window.authAdapter;



// WEBPACK FOOTER //
// ./src/lib/AuthAdapter.js